import React from 'react';
import { observer, inject } from 'mobx-react';
import MaterialTable, { MTableToolbar } from "material-table";
import { useEffect } from 'react';
import { chameleonAdminsMaterialTableHeaderColumns, qarManagersOptions } from '../../helper/constants';
import Grid from "@material-ui/core/Grid";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Typography, IconButton } from '@material-ui/core';
import { HtmlTooltip } from '../HtmlTooltip/HtmlTooltip';

const QarChameleonAdminEmployeeReviews = inject('RootStore')(observer(({ RootStore }) => {

    useEffect(() => {
        RootStore.qarStore.getChameleonAdminsEmployeeReviewsPerAccount(RootStore.qarStore.currentlySelectedAccountForReview.id, RootStore.qarStore.currentComplianceReviewId);
        RootStore.accountStore.getUpdatedDateBySelectedAccount();
    }, [])

    return (
        <MaterialTable
            title=""
            data={RootStore.qarStore.chameleonAdminEmployeeReviews}
            options={qarManagersOptions}
            columns={chameleonAdminsMaterialTableHeaderColumns}
            localization={{
                toolbar: {
                    exportCSVName: "Export as XLSX",
                }
            }}
            components={{
                Toolbar: (tableProps) => (
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item sm={4}>
                            <h4 style={{ marginLeft: '10px' }}>
                                {"Employee Reviews Of Chameleon Admins"}
                            </h4>
                        </Grid>
                        <Grid item sm={3} style={{ textAlign: 'right' }}>
                            <h4>{new Date(RootStore.accountStore.selectedAccountLastUpdatedDate).toUTCString()}</h4>
                            ({new Date(RootStore.accountStore.selectedAccountLastUpdatedDate).toLocaleString()} local time)
                        </Grid>
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    <Typography color="inherit" variant="caption">
                                        This is the selected system's last successful update date.
                                    </Typography>
                                </React.Fragment>
                            }
                        >
                            <IconButton aria-label="delete" size="small">
                                <HelpOutlineIcon fontSize="inherit" />
                            </IconButton>
                        </HtmlTooltip>
                        <Grid item sm={4} style={{ textAlign: 'left' }}>
                            <MTableToolbar {...tableProps} />
                        </Grid>
                    </Grid>
                )
            }}
        />
    )
}));

export default QarChameleonAdminEmployeeReviews;